var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deployedInstance"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t("WorkspaceEdit.appDetails.labels.deployedInstanceType"))+":")])]),_c('p',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }